import { State } from '../reducers/rootReducer'

const equipmentHaveAudiExclusiveSelector = (state: State): boolean => state.equipmentHaveAudiExclusive

export default equipmentHaveAudiExclusiveSelector
